import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

const YearPickerInput = ({label, className, isRequired, id}) => {

  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={`form-item year-picker ${className}`}>
      <DatePicker
        id={id}
        selected={startDate}
        onChange={date => setStartDate(date)}
        showYearPicker
        dateFormat="yyyy"
        required={isRequired}
        className="date-picker"
      />
      {label && <label htmlFor={id}
        className={isRequired && 'required'}>{label}</label>}
    </div>
  )
};

YearPickerInput.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  id: PropTypes.string,
}

YearPickerInput.defaulProps = {
  isRequired: false,
  id: '',
}

export default YearPickerInput;
